import { TRANSLATION_KEYS } from './translationKeys';
import { TFunction } from 'i18next';

/**
 * Get localization text for the DataGrid component
 * @param t Translation function from useTranslation hook
 * @returns Localization text object for DataGrid
 */
export const getDataGridLocalization = (t: TFunction) => ({
  footerOf: t(TRANSLATION_KEYS.DATA_GRID.PAGINATION.DISPLAY_ROWS),
  MuiTablePagination: {
    labelRowsPerPage: t(TRANSLATION_KEYS.DATA_GRID.PAGINATION.ROWS_PER_PAGE),
    labelDisplayedRows: ({
      from,
      to,
      count,
    }: {
      from: number;
      to: number;
      count: number;
    }) =>
      `${from}–${to} ${t(
        TRANSLATION_KEYS.DATA_GRID.PAGINATION.DISPLAY_ROWS,
      )} ${count}`,
  },
  firstPageTooltip: t(TRANSLATION_KEYS.DATA_GRID.PAGINATION.FIRST_PAGE),
  lastPageTooltip: t(TRANSLATION_KEYS.DATA_GRID.PAGINATION.LAST_PAGE),
  nextPageTooltip: t(TRANSLATION_KEYS.DATA_GRID.PAGINATION.NEXT_PAGE),
  previousPageTooltip: t(TRANSLATION_KEYS.DATA_GRID.PAGINATION.PREVIOUS_PAGE),
});
